import { snackError, snackSuccess } from '../utils/snackbarBus';

export const API_URL =
  process.env.REACT_APP_API_URL ||
  process.env.LOCAL_API_URL ||
  'https://srv942210.hstgr.cloud/api';

async function safeJson(response) {
  try {
    return await response.json();
  } catch {
    return null;
  }
}

function buildSuccessMessage(method, modelLabel) {
  const suffix = modelLabel ? ` ${modelLabel}` : '';
  switch ((method || 'GET').toUpperCase()) {
    case 'POST':
      return `Se ha creado${suffix} correctamente.`;
    case 'PUT':
    case 'PATCH':
      return `Se ha actualizado${suffix} correctamente.`;
    case 'DELETE':
      return `Se ha eliminado${suffix} correctamente.`;
    default:
      return null;
  }
}

async function handleResponse(response) {
  const data = await safeJson(response);
  if (!response.ok) {
    const message = (data && (data.error || data.message)) || response.statusText || 'Request failed';
    const error = new Error(message);
    if (data && data.details) error.details = data.details;
    throw error;
  }
  return (data && (data.data ?? data)) ?? null;
}

/**
 * @param {string} path e.g. "/clients"
 * @param {Object} [options]
 * @param {'GET'|'POST'|'PUT'|'PATCH'|'DELETE'} [options.method]
 * @param {any} [options.body] object (JSON) or FormData
 * @param {Record<string,string>} [options.headers]
 * @param {string} [options.modelLabel] e.g. "cliente"
 * @param {string|false} [options.successMessage] custom message or false to disable
 * @param {boolean} [options.showErrorSnack] default true
 */
export async function apiRequest(
  path,
  { method = 'GET', body, headers, modelLabel, successMessage, showErrorSnack = true } = {}
) {
  const upperMethod = method.toUpperCase();

  const init = { method: upperMethod, headers: { ...(headers || {}) } };

  if (body !== undefined) {
    if (body instanceof FormData) {
      init.body = body;
      // Let the browser set the multipart boundary.
    } else {
      init.headers['Content-Type'] = init.headers['Content-Type'] || 'application/json';
      init.body = typeof body === 'string' ? body : JSON.stringify(body);
    }
  }

  try {
    const response = await fetch(`${API_URL}${path}`, init);
    const result = await handleResponse(response);

    const shouldSnack = upperMethod !== 'GET' && successMessage !== false;
    if (shouldSnack) {
      const msg = successMessage || buildSuccessMessage(upperMethod, modelLabel);
      if (msg) snackSuccess(msg);
    }

    return result;
  } catch (err) {
    if (showErrorSnack) {
      const msg = err?.message ? `Error: ${err.message}` : 'Error: Request failed';
      snackError(msg, 3800);
    }
    throw err;
  }
}

